<template>
  <div class="cleaning-categories">
    <h2 class="form-head mb-4 pt-sm-4">Choose Cleaning Category</h2>
    <div class="col-md-12 my-5">
      <div class="carousel-wrapper mobile-carousel">
        <carousel :navigationEnabled="true" :paginationEnabled="true" :autoplay="false" :spacePadding="0"
          :perPageCustom="[[0, 1], [653, 2], [1024, 2]]" :paginationPadding="3" class="mx-auto">
          <spinner :show="loading" message="Loading" />
          <slide v-for="(category, categoryKey) in categories" :key="categoryKey">
            <div class="card booking-card">
              <img :src="category.image" class="card-img-top" :alt="category.name" />
              <div class="card-body">
                <h5 class="card-title">{{ category.name }}</h5>
                <p class="card-text">{{ category.description }}</p>

                <select-button @click="categoryClick(categoryKey)" :status="selected === categoryKey" />
              </div>
            </div>
          </slide>
        </carousel>
      </div>
    </div>

  </div>

</template>

<script>

import { Carousel, Slide } from 'vue-carousel'
import Spinner from '@/shared/inline_spinner.vue'
import { formatCurrency } from '@/utils'
import SelectButton from './select_button.vue'

export default {
  props: {
    categories: {
      type: Object,
      required: true
    },
    selected: {
      type: String,
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Carousel,
    Slide,
    SelectButton,
    Spinner
  },
  methods: {
    formatCurrency(cents) {
       return formatCurrency(cents / 100)
    },
    categoryClick(categoryKey) {
      this.$emit("update", { attr: "category", value: categoryKey })
      if (this.selected) {
        this.$emit("update", { attr: "plan", value: "standard" })
      }
    },
  },
}
</script>

<style lang="css" scoped>
.carousel-wrapper {
  margin: 0 auto;
}

.booking-card {
  margin: 0px;
  border-radius: 10px;
  max-width: 270px;
  overflow: hidden;
  transition: transform 0.3s ease;
  border: 1 solid #ccc;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

@media (max-width: 652px) {
  .mobile-carousel {
    max-width: 350px;
  }

  .booking-card {
    max-width: 340px;
    overflow: hidden;
    transition: transform 0.3s ease;
    border: 1 solid #ccc;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
}

.card-title {
  font-size: 1.1rem;
  font-weight: light;
  margin-bottom: 15px;
}

.card-text {
  font-size: 0.8rem;
  margin-bottom: 15px;
}

.btn-card {
  padding: 5px 0px;
  font-size: 0.8rem;
}
</style>
